import { useState, useRef, useEffect } from "react";
import ButtonSectionHeader from "../../components/ButtonSectionHeader";

export default function PrintExportMenu({
  onSelect,
  hasData = true,
  onNoData,
}) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (open && menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  return (
    <div ref={menuRef} style={{ position: "relative" }}>
      <ButtonSectionHeader
        icon="/images/printer-white.svg"
        text="Imprimir"
        onClick={() => {
          if (!hasData) {
            setOpen(false);
            onNoData && onNoData();
            return;
          }
          setOpen((prev) => !prev);
        }}
      ></ButtonSectionHeader>
      {open && (
        <ul
          className="floating-menu"
          style={{
            zIndex: 100,
            marginTop: 20,
            top: "100%",
            bottom: "unset",
            width: 110,
          }}
        >
          <li
            onClick={() => {
              setOpen(false);
              onSelect && onSelect("csv");
            }}
          >
            CSV
          </li>
          <li
            onClick={() => {
              setOpen(false);
              onSelect && onSelect("excel");
            }}
          >
            Excel
          </li>
          <li
            onClick={() => {
              setOpen(false);
              onSelect && onSelect("pdf");
            }}
          >
            PDF
          </li>
        </ul>
      )}
    </div>
  );
}
